<template>
  <v-card outlined style="margin-bottom: 24px;">
    <UpdateLeadSaleForm
      :state="updateLeadDialog"
      :profile="profile"
      :products="products"
      :inChargeList="inCharge"
      @refresh="refresh"
      @closeDialog="closeUpdate"
    />
    <div class="d-flex justify-space-between align-items-center py-6  pl-6">
      <h5 class=" text-uppercase align-self-center">Phân loại và phân công chăm sóc</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="updateLead"
        style="height: 18px;"
        v-if="authorized"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhập
      </v-btn>
    </div>
    <v-row class=" px-6" no-gutters>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Phân khúc</p>
        <p class=" mt-0 mb-6">{{ profile.segment ? formatLead(profile.segment) : 'Chưa có thông tin' }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Hệ đào tạo quan tâm</p>
        <p class=" mt-0 mb-6">
          <template v-if="profile.products && hasNonEmptyProducts(profile.products)">
            <template v-for="(product, index) in profile.products">
              <a
                v-if="product"
                :key="index"
                :href="`/admin/product/${product.id}`"
                style="text-decoration: none;"
                target="_blank"
                >{{ product.name }}</a
              >
              <span v-if="index < profile.products.length - 1" :key="'comma-' + index">, </span>
            </template>
          </template>
          <span v-else>Chưa có</span>
        </p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Mức độ quan tâm</p>
        <p class=" mt-0 mb-6">{{ profile.interest ? formatLead(profile.interest) : 'Chưa có thông tin' }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Ghi chú</p>
        <v-tooltip bottom max-width="180">
          <template v-slot:activator="{on}">
            <p class="note-text mt-0" v-on="on">{{ profile.note }}</p>
          </template>
          <span>{{ profile.note ? profile.note : 'Không có' }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="px-6" no-gutters>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Người tạo</p>
        <p class="mt-0 mb-6">{{ formatLead(profile.createdByName) }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Ngày tạo</p>
        <p class="mt-0 mb-6">{{ formatTime(profile.createdAt) }}</p>
      </v-col>

      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Nguồn marketing</p>
        <p class=" mt-0 mb-6">{{ profile.importOrigin ? profile.importOrigin : 'Chưa có' }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Người chịu trách nhiệm</p>
        <p class=" mt-0 mb-6">
          <template v-if="profile.inCharge && profile.inCharge.length > 0">
            <template v-for="(inCharge, index) in profile.inCharge">
              <template v-if="user.role.type === 'admin'">
                <a :key="index" :href="`/admin/sale/${inCharge.id}`" style="text-decoration: none;" target="_blank">
                  {{ inCharge.name ? inCharge.name : inCharge.username }}
                </a>
              </template>
              <template v-else>
                <span :key="index">{{ inCharge.name ? inCharge.name : inCharge.username }}</span>
              </template>
              <span v-if="index < profile.inCharge.length - 1" :key="'comma-' + index">, </span>
            </template>
          </template>
          <span v-else>Chưa có</span>
        </p>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import moment from 'moment'
import {mapGetters} from 'vuex'
import formatLead from '@/helpers/translateLead.js'
import UpdateLeadSaleForm from '@/components/basic/form/UpdateLeadSaleForm.vue'
export default {
  props: {
    profile: Object,
    inCharge: Array,
    products: Array,
    authorized: Boolean
  },
  components: {
    UpdateLeadSaleForm
  },
  data() {
    return {
      updateLeadDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    formatTime(time) {
      return moment(time).format('DD/MM/YYYY')
    },
    updateLead() {
      this.updateLeadDialog = true
    },
    closeUpdate() {
      this.updateLeadDialog = false
    },
    refresh() {
      this.$emit('refresh')
    },
    formatLead(data) {
      return formatLead(data)
    },
    hasNonEmptyProducts(products) {
      return products.some(product => Object.keys(product).length > 0)
    }
  }
}
</script>

<style>
.note-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
